<!-- 信息展示列表：模块头+标题+时间 -->
<template>
<div class="content-block">
  <div class="info-list-title">
    <span>{{title}}</span>
    <label>{{label}}</label>

  </div>
  <div class="info-list-content">
    <ul>
      <li v-for="news in newsList">
        <a href="#">
          <div class="title">{{news.title.length>titleLength?news.title.substring(0,titleLength)+'...':news.title}}</div>
        </a>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
export default {
  name: 'InfoList04',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '3'
    }
  },
  data() {
    return {
      newsList:[],
    }

  },
  created:function(){
    this.newsList=this.Global.newsListDemo.slice(0,this.count);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  width: 100%;
  margin: 0px 0px 2px 0px;
  height:26px;
}

li .title{
  position:relative;
  width: 100%;
  height:25px;
  font-size:12px;
  font-weight:400;
  line-height:25px;
  text-align:left;
}

li .title span{
  font-size:14px;
  color:var(--color6);
  letter-spacing:3px;
}

li .label{
  position:relative;
  width: 100%;
  padding-right:10px;
  font-size:14px;
  color:#9FA2A6;
  line-height:20px;
  text-align:left;
}

li a{
  display:block;
  height:80px;
  padding:10px 0px 10px 0px;
  color:#282A2B;

}

li a:hover{
  color: var(--color6);
}

a {
  color: #42b983;
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoList04.vue